import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl, carImageUrl } from '../Config/Config';
import axios from 'axios';
import { Scrollbars } from 'react-custom-scrollbars';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


//import {GET_VEHICLETYPE, GET_ADDCAR }  from '../../actions'; 


const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
  
const initialState = {
			vehicle_name:'',
			vehicle_price:'',
			localRideBasePrice:'',
			longRideBasePrice:'',
			vehicle_color:'',
			
			vehicle_model:'',			
			selectedvalue: '',
            selectedOption:{ value: 'active', label: 'Active'},
			selectedsizevalue: '',
            selectedsizeOption:{ value: '350x350', label: '350x350'},
			user_image: [],
			vehicletype:[],
			user_image_name: [],
			user_image_preview: [],
			image: [],
			isHidden: false,
			statusmessage:'',
			selectedVehicle:'',
			vehiclevalue:'',
			Loading:false,
			fileName: [],
			thumbDefault: null,
			priority: "",	
			short_desc : '',	
			feature_description: '',	
			
			
			admin_id: localStorage.getItem('admin_id'),
			enableuploadgalley: false,
			imagelist:'',
			selectedimages:[],
			galleryimg: 'No',
            vehicleTypeOption:[
				{ value: 'Gas', label: 'Gas'},
				{ value: 'Regular', label: 'Regular'},
				{ value: 'EV', label: 'EV'},
			],			
            selectedVehTypeOption: { value: 'Gas', label: 'Gas'},			
			selectedVehTypeValue:'',
			car_addition_charges: '',
			cancellation_hour: '',
			cancellation_fee: '',
			cancellation_charge_type_sel: { value: 'Flat', label: 'Flat'},
			cancellation_charge_type: 'Flat',
			vehicleImgWidth: '',
			vehicleImgHeight: '',
			items: [
				{ image: null, preview: "", description: "" }
			],
			localRidePerMile: '',
			longRidePerMile: '',
			longRidePerMin: '',
			localRidePerMin: '',
			tollCharge: '',
			mediumRideBasePrice:'',
			mediumRidePerMin:'',
			mediumRidePerMile:'',
			mediumRideMaxMiles:'',
			ultraLongRideBasePrice:'',
			ultraLongRidePerMin:'',
			ultraLongRidePerMile:'',
			ultraLongRideMaxMiles:'',
			localRideMaxMiles:'',
			longRideMaxMiles:'',
			localRideStopfee:'',
			mediumRideStopfee:'',
			longRideStopfee:'',
			ultraLongRideStopfee:'',
			db_map_icon: '',
			map_icon_img:"",
			selectedCateOption: '',
			selectedCatevalue:'',

		};
		
class Add extends Component {
	
	fileObj = [];
    fileArray = [];
    imageArray = [];
	
	constructor(props)
	{
		CheckAuth();
		super(props);	
		this.state =  { ...initialState }
		
	   this.handleInputChange = this.handleInputChange.bind(this);
	   this.handleChange = this.handleChange.bind(this);
	   this.handleReset = this.handleReset.bind(this);
	   this.handlesizeChange = this.handlesizeChange.bind(this);
	   this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this);
	   this.onEditorChange = this.onEditorChange.bind( this );

    }

	handleAddMore = () => {
		this.setState(prevState => ({
		items: [
			...prevState.items,
			{ image: null, preview: "", description: "" }
		]
		}));
	};

	// Remove clone
	handleRemove = index => {
		const items = [...this.state.items];

		if (items[index].preview) {
			URL.revokeObjectURL(items[index].preview);
		}

		items.splice(index, 1);
		this.setState({ items });
	};


	// Handle image upload
	handleImageChange = (index, event) => {
		const file = event.target.files[0];
		if (!file) return;

		const items = [...this.state.items];

		items[index] = {
			...items[index],
			image: file,
			preview: URL.createObjectURL(file)
		};

		this.setState({ items });
	};


	// Handle description change
	handleDescriptionChange = (index, event) => {
		const items = [...this.state.items];
		items[index].description = event.target.value;
		this.setState({ items });
	};
	onEditorChange(r, evt) {
		if(r == 'short_desc'){
			const converted = this.emojiToEntity(evt);
			this.setState({ short_desc: converted });
		}		
	}
	emojiToEntity(str) {
		return str.replace(/\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu, emoji => {
			return `&#${emoji.codePointAt(0)};`;
		});
	}


	handleReset() {
         this.setState(initialState);
		 this.fileObj = [];
		 this.fileArray = [];
		 this.imageArray = [];
    }

    //handleChange = selectedOption => {
	handleChange = (r,selOption) => {
        // this.setState({selectedOption})
        // this.setState({  selectedvalue : selectedOption.value});
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}else if(r == 'vehicleType'){			
			this.setState({selectedVehTypeOption:selOption})
			this.setState({  selectedVehTypeValue : selOption.value});
		}
		else if(r == 'cancellationChargeType'){			
			this.setState({cancellation_charge_type_sel:selOption})
			this.setState({  cancellation_charge_type : selOption.value});
		}
		else if(r == 'cate'){			
			this.setState({selectedCateOption:selOption})
			this.setState({  selectedCatevalue : selOption.value});
			$('.errorcate').html('');
		}
    };
	handlesizeChange = selectedsizeOption => {
        this.setState({selectedsizeOption})
        this.setState({  selectedsizevalue : selectedsizeOption.value});
		
    };
   handleInputChange(event) {

      const {name, value} = event.target;    
      this.setState({
          [name]: value
        });
    }

	componentDidMount() {
		document.title = PageTitle('Car Add');
    }

   handleChangeVehicle = selectedVehicle => {
      this.setState({ selectedVehicle});
      this.setState({ vehiclevalue : selectedVehicle.value });
      if(selectedVehicle.value ==''){
        $('.errorvehicletype').html('<span class="errorspan">Please fill the field</span>');
      }

      let vehicletruck = selectedVehicle.label;
      let lowercasetext = vehicletruck.toLowerCase();
      if(lowercasetext == 'truck'){
      	this.setState({enableweight: true})
      }else{
      	this.setState({enableweight: false})
      }
   }


onThumbChanged = (e) => {
    this.setState({
      thumbDefault: e.currentTarget.value
      });
  }
  
uploadMultipleFiles = (e) =>{

		this.fileObj = [];
        this.fileObj.push(e.target.files)
        for (let i = 0; i < this.fileObj[0].length; i++) {
            this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
            //this.fileArray.push(this.fileObj[0][i])
            this.imageArray.push(this.fileObj[0][i])

        }
        this.setState({ user_image: this.imageArray });			
	
    }
	
	 handleFormSubmit = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				 const config = {
			        headers: {
			          'Content-Type': 'multipart/form-data'
			        }
			      };

				const formPayload = this.state;
				var qs = require('qs');
				var status = '';
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
				}else{
				status = formPayload.selectedvalue;
				}
				
				var imgSize = '';
				if(formPayload.selectedsizevalue === ''){
				imgSize =formPayload.selectedsizeOption.value;
				}else{
				imgSize = formPayload.selectedsizevalue;
				}

				var cate ='';	
				if(formPayload.selectedCatevalue === '' && formPayload.selectedCatevalue!== 0){
					cate =formPayload.selectedCateOption.value;
				}else{
					cate = formPayload.selectedCatevalue;
				}
                
                var galleryimg = 'No';
				if(Object.keys(formPayload.selectedimages).length >0){
                   galleryimg = 'Yes';
				}

				var postObject = {
					admin_id : localStorage.getItem("admin_id"),
					vehicle_name: formPayload.vehicle_name,
					vehicle_price:formPayload.vehicle_price,
					localRideBasePrice:formPayload.localRideBasePrice,
					longRideBasePrice:formPayload.longRideBasePrice,
					vehicle_color:formPayload.vehicle_color,
					vehicle_model: formPayload.vehicle_model,
					car_addition_charges: formPayload.car_addition_charges,
					cancellation_hour: formPayload.cancellation_hour,
					cancellation_charge_type: formPayload.cancellation_charge_type,
					cancellation_fee: formPayload.cancellation_fee,
					vehicle_width: formPayload.vehicleImgWidth,
					vehicle_height: formPayload.vehicleImgHeight,
					short_desc: formPayload.short_desc,
					feature_description: formPayload.feature_description,
					vehicle_image        : formPayload.user_image,
					vehicle_status      :status,
					image_size      :imgSize,
					thumbDefault :  formPayload.thumbDefault,
					priority        : formPayload.priority,
					service_id :formPayload.service_id,
					vehicle_type        : formPayload.selectedVehTypeValue,
					cate_id:cate,
					localRidePerMile        : formPayload.localRidePerMile,
					longRidePerMile        : formPayload.longRidePerMile,
					localRidePerMin        : formPayload.localRidePerMin,
					longRidePerMin        : formPayload.longRidePerMin,
					tollCharge        : formPayload.tollCharge,
					uploadfromgallery : galleryimg,
					mediumRideBasePrice:formPayload.mediumRideBasePrice,
					mediumRidePerMin:formPayload.mediumRidePerMin,
					mediumRidePerMile:formPayload.mediumRidePerMile,
					mediumRideMaxMiles:formPayload.mediumRideMaxMiles,
					ultraLongRideBasePrice:formPayload.ultraLongRideBasePrice,
					ultraLongRidePerMin:formPayload.ultraLongRidePerMin,
					ultraLongRidePerMile:formPayload.ultraLongRidePerMile,
					ultraLongRideMaxMiles:formPayload.ultraLongRideMaxMiles,
					localRideMaxMiles:formPayload.localRideMaxMiles,
					longRideMaxMiles:formPayload.longRideMaxMiles,
					localRideStopfee:formPayload.localRideStopfee,
					mediumRideStopfee:formPayload.mediumRideStopfee,
					longRideStopfee:formPayload.longRideStopfee,
					ultraLongRideStopfee:formPayload.ultraLongRideStopfee
				};
				console.log(postObject,'postObject');
				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}
                
                var filesdata;
                if(galleryimg == 'No'){
                    filesdata = this.state.user_image;	
                }else{
                	 filesdata = this.state.selectedimages;	
                }
				
				
				for (var i in filesdata) {
				 formData.append('vehicle_image[]',filesdata[i])
				}

				// ===== CLONE-WISE IMAGE + DESCRIPTION =====
				if (Array.isArray(formPayload.items)) {
					formPayload.items.forEach(item => {
						if (item.image instanceof File) {
							formData.append("feature_image[]", item.image);
						} else {
							formData.append("feature_image[]", "");
						}

						formData.append(
							"feature_description[]",
							item.description ? item.description.trim() : ""
						);
					});
				}

				if(this.state.map_icon_img ) {
					 formData.append('map_icon', this.state.map_icon_img);
				}
											
				axios.post(apiUrl+"vehicle/add",formData).then(res => {
				 
					if(res.data.status === 'success'){
					   $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
						   this.setState({
							vehicle_name: '',
							vehicle_price:'',
							localRideBasePrice:'',
							longRideBasePrice:'',
							vehicle_color:'',
							vehicle_model: '',
							vehicle_image : '',
							vehicle_status :'',
							car_addition_charges: '',
							cancellation_hour: '',
							cancellation_charge_type: '',
							cancellation_fee: '',
							vehicleImgWidth : '',
							vehicleImgHeight : '',
							image_size :'',
							thumbDefault:  '',
							priority : '',
							service_id:'',
							uploadfromgallery: '',
							items: [{ image: null, description: "" }],
							localRidePerMile: '',
							longRidePerMile: '',
							localRidePerMin: '',
							longRidePerMin: '',
							tollCharge: '',
							mediumRideBasePrice:'',
							mediumRidePerMin:'',
							mediumRidePerMile:'',
							mediumRideMaxMiles:'',
							ultraLongRideBasePrice:'',
							ultraLongRidePerMin:'',
							ultraLongRidePerMile:'',
							ultraLongRideMaxMiles:'',
							localRideMaxMiles:'',
							longRideMaxMiles:'',
							localRideStopfee:'',
							mediumRideStopfee:'',
							longRideStopfee:'',
							ultraLongRideStopfee:'',
							map_icon_img:''
						   });
						   setTimeout(
						   function() {
					
							   $('.success_message').html('');
									this.props.navigate('/vehicle');
						   }
						   .bind(this),
						   2000
						   );
					   }else{
						this.setState({Loading:false});
						   $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
						   setTimeout(
						   function() {
							   $('.success_message').html('');
						   }
						   .bind(this),
						   2000
						   );
					   }
				  }); 
			}
	}

	validateForm() {
		const {vehicle_name,vehicle_color,vehicle_price,vehicle_model,selectedVehicle,user_image, cancellation_charge_type, cancellation_fee,selectedCateOption} = this.state;
		let errors = 0;
	const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/svg+xml'];
		let maxSize = 1000000;//1 mb
		if (!vehicle_name) {
			errors++;
			$('.errorvehicle_name').html('<span class="errorspan">Please fill the field</span>');
		}else if(vehicle_name){
			$('.errorvehicle_name').html('');
		}


		// if (!vehicle_price) {
		// 	errors++;
		// 	$('.errorvehicle_price').html('<span class="errorspan">Please fill the field</span>');
		// }else if(vehicle_price){
		// 	$('.errorvehicle_price').html('');
		// }
	
		if (!vehicle_model) {
			errors++;
			$('.errorvehicle_model').html('<span class="errorspan">Please fill the field</span>');
		}else if(vehicle_model){
			$('.errorvehicle_model').html('');
		}
		

		
		if(user_image.length == 0){
			errors++;
			$('.errorcarimage').html('<span class="errorspan">Please upload vehicle images</span>');
		}
		else if(user_image) {	 
			
			for (let i = 0; i < user_image.length; i++) 
			{

				const file = user_image[i];
				const filename = file.name;

				
				if (!allowedTypes.includes(file.type)) {
					errors++;
				
				$('.errorcarimage').html('<span class="errorspan"> '+filename+' file type is Invalid.</span>');

				continue;
				}
			}
		}
		// Cancellation Fee Validation
		if (!cancellation_fee) {
			errors++;
			$('.errorcancellation_fee').html('<span class="errorspan">Please fill the field</span>');
		}
		else if (!/^\d+$/.test(cancellation_fee)) {
			errors++;
			$('.errorcancellation_fee').html('<span class="errorspan">Only numbers allowed</span>');
		}
		else if (
			this.state.cancellation_charge_type === 'Percentage' &&
			parseInt(cancellation_fee) > 100
		) {
			errors++;
			$('.errorcancellation_fee').html('<span class="errorspan">Percentage cannot be more than 100</span>');
		}
		else {
			$('.errorcancellation_fee').html('');
		}

		if(selectedCateOption == ''){
			errors++;
			$('.errorcate').html('<span class="errorspan">Please select a value</span>');
		}else {
			$('.errorcate').html('');
		}


		if(errors>0) { 
			setTimeout(function () {
			scrollToTopValidate();
			}, 100);
			return false;
		}
		else { 
			return true;
		}

    }

    
	removeImagebyindex = (indexvalue) => {
  	 
	  var list = [...this.imageArray];
	  this.imageArray = [];
	  this.fileArray = [];
	  list.splice(indexvalue, 1);
	 
	  for (let i = 0; i < list.length; i++) {
		this.imageArray.push(list[i]);
		this.fileArray.push(URL.createObjectURL(list[i]));
	  }
	
		this.setState({ user_image: this.imageArray })
		
		var thumbDefault = this.state.thumbDefault;
		if(indexvalue <= thumbDefault){
			let thum = thumbDefault-1;
			 if(thum < 0 ){
			   this.setState({thumbDefault : 0})
			 }else{
				this.setState({thumbDefault : thum});
			}    
		}
	}
	
	
	 getImagesFrontUpload(){
		 /*====Thumb image while choosing from front end===*/
		  if(Object.keys(this.fileArray).length > 0) {
			var thumbDefaultArr = this.state.thumbDefault;
		 
			 const imgThumblist = this.fileArray.map((url, index) => {
						var indicheckFlag = false;
												
						//if(Object.keys(thumbDefaultArr).length > 0){
							if(thumbDefaultArr != null && thumbDefaultArr == index){
								indicheckFlag = true;
							}
						//}
						  return (
							<li className="thumb" key={index}  >
								<input type="radio" name="sel_img" id="sel_img"  value={index} onClick={this.onThumbChanged} checked={indicheckFlag} />
								<span><img src={url}  alt="..." /></span>
								<a href="javascript:void(0);" onClick={this.removeImagebyindex.bind(this,index)}>X</a>
							</li>
							 );
			 });	
				return imgThumblist;					
			/*=======*/
		}
	 }

   //list selected image  from gallery
	 getafteruploaded(){
	 	var imgArray = this.state.selectedimages;
	 	if(Object.keys(imgArray).length > 0) {
		 	var thumbDefaultArr = this.state.thumbDefault;
			 const imgThumblist = imgArray.map((images, index) => {
			 	console.log(images,'images')
			 			var indicheckFlag = false;
		 				if(thumbDefaultArr != null && thumbDefaultArr == index){
							indicheckFlag = true;
						} 
						  return (
							<li className="thumb" key={index}  >
								<input type="radio" name="sel_img" id="sel_img"  value={index} onClick={this.onThumbChanged} checked={indicheckFlag} />
								<span><img src={carImageUrl+'/'+images}  alt="..." /></span>
								<a href="javascript:void(0);" onClick={this.removeImagebyindex.bind(this,index)}>X</a>
							</li>
							 );
			 });	
				return imgThumblist;					
			/*=======*/
		}

	 }
  //check gallery images
   Checkgallery = (indexs,value) =>{
      var imageArr = [...this.state.selectedimages];
      const index = imageArr.findIndex(images => images === indexs);
      if(index > -1) {
     	 imageArr = [...imageArr.slice(0, index), ...imageArr.slice(index + 1)]
      } else {
      imageArr.push(value);
      }
      this.setState({selectedimages: imageArr});
  }


 getGalleryimages() {
    var imageArr = this.state.imagelist;
    if(imageArr!== undefined && imageArr!== null){
      if(Object.keys(imageArr).length > 0) {
         const imageDetails = imageArr.map((image, Index) => {
       		var checked = false;
            return (
                        <div className="asp-col" key={Index}>   
                        <input type="checkbox" name="gallery_img" value={Index}  onClick={this.Checkgallery.bind(this,Index,image['name'])} />
                        <label><img src={image['url']} alt="" className="" /></label>
                        </div>
                     );
    
     });
      return imageDetails;
     }
    } else {
      return (<div className="">No images found</div>);
    }
  }

   galleryClose = () => {

   		if(Object.keys(this.state.selectedimages).length > 0){
   			 this.setState({galleryimg: 'Yes'});
   		}
   	    this.setState(prevState => ({
			enableuploadgalley: !prevState.enableuploadgalley
		}));
		$('.cargallery-popup').removeClass('active');
   }

   mapIconUpload = event => {
		let reader = new FileReader();
		const file = event.target.files[0];

		reader.onloadend = () => {
			this.setState({
				db_map_icon: '',
				map_icon_img:file,
			    map_icon_preview: reader.result,
			});
		}
		reader.readAsDataURL(file);
    }

	removeMapIcon = () =>{
		this.setState({
			map_icon_img: "",
			map_icon_preview: "",
			db_map_icon:"", 
		});
    }


  render() {

  	
	let imagesrc = '';
	
  	const {selectedOption,selectedVehicle, user_image_preview, selectedVehTypeOption,selectedCateOption} = this.state;

	var mapIconPreview =''
	if(this.state.map_icon_img!=''){
		mapIconPreview = <img className="img_class" src={this.state.map_icon_preview} alt="" width={100} height={100}/>;
	}

    return (
    	<div className="wrapper"> 
 
	  	<Header />
    	<MenuSidebar currentpage="vehicle"  currentTab="car" />  
	
		<div className="content">	
			<div className="content-wrapper">
				<div class="content-wrapper-before"></div>
				<div className="form-wrapper leaa-admin-head card">
					<div className="success_message"></div>
					<div>
						<a class="primary-btn" href="/vehicle">Back</a>
					</div>
					<div className="title">
						<h4>Add Vehicle</h4>
					</div>
					<form className="login" id="login" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>
						<div className="form-row">
							<div className="form-left">
								<div className="form-group">
									<label>Vehicle Name:</label>
									<input type="text" name="vehicle_name" onChange={this.handleInputChange} className="form-control" value={this.state.vehicle_name} />
									<div className="errorvehicle_name"></div>
								</div>
								
								
							
								{/*<div className="form-group">					
									<label>Image Size:</label>
									<Select 
									value={this.state.selectedsizeOption?this.state.selectedsizeOption:{ value: '350x350', label: '350x350'}}
										options={lang.common.image_size_option} 
										onChange={this.handlesizeChange}
										/>
								</div>*/}

								<div className="form-group">					
									<label>Category<span class="required" style={{ color: "red" }} > * </span> :</label>
									<Select 
									value={selectedCateOption?selectedCateOption:""}
										options={lang.common.vehicleCategories_option} 
										onChange={this.handleChange.bind(this, 'cate')}
										/>
										<div className="errorcate"></div>
								</div>
								<div className="form-group">
									<label>Color:</label>
									<input type="text" name="vehicle_color" onChange={this.handleInputChange} className="form-control" value={this.state.vehicle_color} autoComplete="off" />
									<div className="errorvehicle_color"></div>
								</div>
								<div className="form-group">
									<label>Additional Charges (per mile): </label>
									<input type="text" name="car_addition_charges" onChange={this.handleInputChange} className="form-group" value={this.state.car_addition_charges} />
								</div>
								{/* <div className="form-group">					
									<label>Local Ride Base Price:</label>
										<input type="text" name="localRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.localRideBasePrice} />
									<div className="errorlocalRideBasePrice"></div>
								</div>
								<div className="form-group">
									<label>Local Ride Charges (per minute): </label>
									<input type="text" name="localRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.localRidePerMin} />
								</div>
								<div className="form-group">
									<label>Local Ride Charges (per mile): </label>
									<input type="text" name="localRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.localRidePerMile} />
								</div> */}
								
								<div className="form-group">
									<label>Cancellation Hours:</label>
									<input type="text" name="cancellation_hour" onChange={this.handleInputChange} className="form-control" value={this.state.cancellation_hour} autoComplete="off" />
									<div className="errorcancellation_hour"></div>
								</div>
								<div className="form-group">					
									<label>Charge Type:</label>
									<Select 
									value={this.state.cancellation_charge_type_sel?this.state.cancellation_charge_type_sel:{ value: 'Flat', label: 'Flat'}}
									options={lang.common.discount_type} 
									onChange={this.handleChange.bind(this, 'cancellationChargeType')}
									/>
								</div>
                               
								<div className="form-group">
									{this.state.cancellation_charge_type == 'Flat' ? 
									<label>Cancellation Charges ($):</label>
									:
									<label>Cancellation Charges (%):</label>}
									<input type="text" name="cancellation_fee" onChange={this.handleInputChange} className="form-control" value={this.state.cancellation_fee} autoComplete="off" />
									<div className="errorcancellation_fee"></div>
								</div>

								 
								<div className="form-group">
									<label>Priority: </label>
									<input type="text" name="priority" onChange={this.handleInputChange} className="form-group" value={this.state.priority} />
								</div>
								

								<div className="form-group">					
									<label>Status:</label>
									<Select 
									value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
									options={lang.common.status_option} 
									onChange={this.handleChange.bind(this, 'status')}
									/>
								</div>
							
								{/* <div className="form-group">
									<label>Vehicle Image Width (px):</label>
									<input type="text" name="vehicleImgWidth" onChange={this.handleInputChange} className="form-control" value={this.state.vehicleImgWidth} autoComplete="off" />
									<div className="errorvehicleImgWidth"></div>
								</div> */}

								
								
								
								

								
														
							</div>				
							<div className="form-right">
								<div className="form-group">
									<label>Model:</label>
									<input type="text" name="vehicle_model" onChange={this.handleInputChange} className="form-control" value={this.state.vehicle_model} />
									<div className="errorvehicle_model"></div>
								</div>
								<div className="form-group">
									<label>Slug: </label>
									<input type="text" name="service_id" onChange={this.handleInputChange} className="form-group" value={this.state.service_id} />
								</div>
								<div className="form-group">					
									<label>Type:</label>
									<Select 
									value={selectedVehTypeOption?selectedVehTypeOption:{ value: '', label: 'Select'}}
									options={this.state.vehicleTypeOption} 
									onChange={this.handleChange.bind(this, 'vehicleType')}
									/>
								</div>
								
								<div className="form-group">
									<label>Toll Charge: </label>
									<input type="text" name="tollCharge" onChange={this.handleInputChange} className="form-group" value={this.state.tollCharge} />
								</div>
								
								{/* <div className="form-group">					
									<label>Long Ride Base Price:</label>
										<input type="text" name="longRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.longRideBasePrice} />
									<div className="errorlongRideBasePrice"></div>
								</div>
								<div className="form-group">
									<label>Long Ride Charges (per minute): </label>
									<input type="text" name="longRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.longRidePerMin} />
								</div>
								<div className="form-group">
									<label>Long Ride Charges (per mile): </label>
									<input type="text" name="longRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.longRidePerMile} />
								</div>
								 */}

								
								
								
								
								
								<div className="form-group">
									<label>Vehicle Image:</label>

									<div className="choose-file">
									{this.state.isHidden && <div className="image_success"></div>}
										<span className="profile_btn">
										<input type="file" className="form-control" name="file" onChange={this.uploadMultipleFiles} multiple />
										</span>
									</div>
									<div className="form-group">
										<ul className="carimagelisting">
											{(this.state.galleryimg === 'No')?this.getImagesFrontUpload():this.getafteruploaded()}
										</ul>
									</div>
									<div className="errorcarimage"></div> 
								</div>
								<div className="form-group">
										<label>Map Icon:</label>
										<div className="choose-file">
										{this.state.isHidden && <div className="image_success"></div>}
											<span className="profile_btn">
											<input type="file" className="form-control" name="file" onChange={this.mapIconUpload} multiple />
											</span>
										</div>
										<div className="form-group">
											{mapIconPreview && mapIconPreview !== '' && <div>{mapIconPreview} <span className='fw-bold cursor-pointer' onClick={this.removeMapIcon}>X</span></div>}

								
										</div>
										<div className="errormapiconimage"></div> 
									</div>
								<div className="form-group">					
									<label>Short Description:</label>						
									<CKEditor
										editor={ ClassicEditor }
										data={this.state.short_desc || ''}
										onReady={ editor => {
											// You can store the "editor" and use when it is needed.
											console.log( 'Editor is ready to use!', editor );
											editor.ui.view.editable.element.style.minHeight = "300px";
										} }
										name="short_desc"
										// onChange={this.handleInputChange}
										onChange={ ( event, editor ) => {
											const data = editor.getData();
											//this.setState({short_desc: data});
											this.onEditorChange('short_desc', data);
											editor.ui.view.editable.element.style.minHeight = "300px";
										} }
									/>
									<div className="errorshort_desc"></div>
								</div>
								{/* <div className="form-group">
									<label>Vehicle Image Height (px):</label>
									<input type="text" name="vehicleImgHeight" onChange={this.handleInputChange} className="form-control" value={this.state.vehicleImgHeight} autoComplete="off" />
									<div className="errorvehicleImgHeight"></div>
								</div> */}


							</div>	
						</div>		

						<div class="title"><h4>Local ride settings</h4></div>

						<div className="form-row">
							<div className="form-left">
								<div className="form-group">					
									<label>Base price:</label>
									<input type="text" name="localRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.localRideBasePrice} />
									<div className="errorlocalRideBasePrice"></div>
								</div>
								<div className="form-group">
									<label>Ride charges (per minute): </label>
									<input type="text" name="localRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.localRidePerMin} />
								</div>
								<div className="form-group">					
									<label>Stop fee:</label>
									<input type="text" name="localRideStopfee" onChange={this.handleInputChange} className="form-control" value={this.state.localRideStopfee} />
									<div className="errorlocalRideStopfee"></div>
								</div>
							</div>
							<div className="form-right">
								    <div className="form-group">
										<label>Max miles: </label>
										<input type="text" name="localRideMaxMiles" onChange={this.handleInputChange} className="form-group" value={this.state.localRideMaxMiles} />
									</div>
									<div className="form-group">
										<label>Ride charges (per mile): </label>
										<input type="text" name="localRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.localRidePerMile} />
									</div>
									
							</div>
						</div>

						<div class="title"><h4>Medium ride settings</h4></div>

						<div className="form-row">
							<div className="form-left">
									<div className="form-group">					
									<label>Base price:</label>
										<input type="text" name="mediumRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.mediumRideBasePrice} />
									<div className="errormediumRideBasePrice"></div>
									</div>
									<div className="form-group">
										<label>Ride charges (per minute): </label>
										<input type="text" name="mediumRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.mediumRidePerMin} />
									</div>
									<div className="form-group">					
										<label>Stop fee:</label>
										<input type="text" name="mediumRideStopfee" onChange={this.handleInputChange} className="form-control" value={this.state.mediumRideStopfee} />
										<div className="errormediumRideStopfee"></div>
									</div>
									
							</div>
							<div className="form-right">
								    <div className="form-group">
										<label>Max miles: </label>
										<input type="text" name="mediumRideMaxMiles" onChange={this.handleInputChange} className="form-group" value={this.state.mediumRideMaxMiles} />
									</div>
									<div className="form-group">
										<label>Ride charges (per mile): </label>
										<input type="text" name="mediumRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.mediumRidePerMile} />
									</div>
									
									
							</div>
						</div>

						<div class="title"><h4>Long ride settings</h4></div>

						<div className="form-row">
							<div className="form-left">
									<div className="form-group">					
									<label>Base price:</label>
										<input type="text" name="longRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.longRideBasePrice} />
									<div className="errorlongRideBasePrice"></div>
									</div>
									<div className="form-group">
										<label>Ride charges (per minute): </label>
										<input type="text" name="longRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.longRidePerMin} />
									</div>
									<div className="form-group">					
										<label>Stop fee:</label>
										<input type="text" name="longRideStopfee" onChange={this.handleInputChange} className="form-control" value={this.state.longRideStopfee} />
										<div className="errorlongRideStopfee"></div>
									</div>
									
							</div>
							<div className="form-right">
								    <div className="form-group">
										<label>Max miles: </label>
										<input type="text" name="longRideMaxMiles" onChange={this.handleInputChange} className="form-group" value={this.state.longRideMaxMiles} />
									</div>
									<div className="form-group">
										<label>Ride charges (per mile): </label>
										<input type="text" name="longRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.longRidePerMile} />
									</div>
									
									
							</div>
						</div>

						<div class="title"><h4>Ultra long ride settings</h4></div>

						<div className="form-row">
							<div className="form-left">
									<div className="form-group">					
									<label>Base Price:</label>
										<input type="text" name="ultraLongRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.ultraLongRideBasePrice} />
									<div className="errorultraLongRideBasePrice"></div>
									</div>
									<div className="form-group">
										<label>Ride charges (per minute): </label>
										<input type="text" name="ultraLongRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.ultraLongRidePerMin} />
									</div>
									<div className="form-group">					
										<label>Stop fee:</label>
										<input type="text" name="ultraLongRideStopfee" onChange={this.handleInputChange} className="form-control" value={this.state.ultraLongRideStopfee} />
										<div className="errorultraLongRideStopfee"></div>
									</div>
									
							</div>
							<div className="form-right">
								<div className="form-group">
									<label>Miles exceeding limit: </label>
									<input type="text" name="ultraLongRideMaxMiles" onChange={this.handleInputChange} className="form-group" value={this.state.ultraLongRideMaxMiles} />
								</div>
								<div className="form-group">
									<label>Ride charges (per mile): </label>
									<input type="text" name="ultraLongRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.ultraLongRidePerMile} />
								</div>	
							</div>
						</div>

						<div className="form-group">
							<label>Amenities:</label>
							<div className='d-flex flex-row flex-wrap justify-content-between w-100 gap-2 m-2'>
							{this.state.items.map((item, index) => (
								<div
								className='form-rowflex-column position-relative end-0 my-4'
								key={index}
								style={{
									border: "1px solid #ccc",
									padding: "15px",
									marginBottom: "10px",
									borderRadius:"15px",
									width:"45%",
								}}
								>
								<div className="form-left">
									<label>Upload Icon</label>
									<input
									type="file"
									accept="image/*"
									className="form-control"
									onChange={e => this.handleImageChange(index, e)}
									/>

									{item.preview && (
									<img
										src={item.preview}
										alt="Preview"
										style={{
										width: "40px",
										height: "40px",
										height: "auto",
										marginTop: "10px",
										marginLeft: "10px",
										borderRadius: "5px",
										border: "1px solid #ddd"
										}}
									/>
									)}
								</div>

								<div className="form-right w-100">
									<label>Description</label>
									<textarea
									className="form-control"
									placeholder="Enter description"
									value={item.description}
									onChange={e => this.handleDescriptionChange(index, e)}
									/>
								</div>

								{/* {this.state.items.length > 1 && (
									<button
									type="button"
									className="btn btn-danger btn-sm"
									onClick={() => this.handleRemove(index)}
									>
									Remove
									</button>
								)} */}

								{this.state.items.length > 1 && (<span class="fw-bold cursor-pointer position-absolute cursor-pointer" onClick={() => this.handleRemove(index)} style={{top:"20px",right:"20px", fontSize:"25px", zIndex:"9"}}>X</span>)}
								</div>
							))}

					
							</div>
								<div className='d-flex justify-content-center w-100'>
							<button
								type="button"
								className="btn btn-primary me-2"
								onClick={this.handleAddMore}
							>
								+ Add More
							</button>
							</div>
						</div>

						<div className="btn-group export">	
							<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true && <span className="load-data"></span> }Submit
							</button>
						</div>
					</form>
				</div>
			</div>	
		</div>
    </div>
    );
  }
}


export default (withRouter(Add));

/*const mapStateTopProps = (state) => {
  return {
  	vehicletype: state.vehicletype,
  	caradd     : state.caradd
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
	 getVehicleType: (adminID) =>{
       dispatch({ type: GET_VEHICLETYPE, adminID});
    },
    getAddCar: (formPayload) =>{
       dispatch({ type: GET_ADDCAR, formPayload});
    }
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(Add));*/